/* eslint-disable max-len */
import React from 'react'
import { useContext } from 'react'
import GlobalContext from '../Context/GloablContext'
function TopHeader({title}) {
    const {isSideBar, setIsSideBar,show, setshow,setToastmessage,isAdvancedSearchOpen} = useContext(GlobalContext);
    
    
    return (
        <header className={`bg-[#F9FCFC] w-full  py-[25px] shadow-s2 fixed top-0 left-0 z-[9]`}>
            <h1 className={`text-xl font-normal text-[#000] ${!isSideBar?'ml-[321px]':'ml-[96px]'}`}>{title}</h1>
        </header>
    )
}
export default TopHeader;